import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestInternalBankReplenishmentUpdate } from "./internalBankReplenishmentUpdate.request";

const useInternalBankReplenishmentUpdate = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchInternalBank = useRefetchQuery(["internal-bank"]);
  const refetchInternalBankHistory = useRefetchQuery(["internal-bank-history"]);

  return useMutation({
    mutationFn: requestInternalBankReplenishmentUpdate,
    ...options,
    onSuccess: (data, variables, context) => {
      refetchInternalBank();
      refetchInternalBankHistory();
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default useInternalBankReplenishmentUpdate;
